import { render, staticRenderFns } from "./Imt.vue?vue&type=template&id=6d0a7cd6&"
import script from "./Imt.vue?vue&type=script&lang=ts&"
export * from "./Imt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports